import React from "react";

import {
  IconButtonProps,
  IconButton as MUIconButton,
  TooltipProps,
} from "@mui/material";

import { SizeProp } from "@fortawesome/fontawesome-svg-core";

import { Icon } from "../Icon/Icon";
import { Tooltip } from "../Tooltip/Tooltip";
import { IconProps } from "../types";

export interface Props extends IconButtonProps {
  iconProps: IconProps & { size?: SizeProp };
  tooltipProps?: Omit<TooltipProps, "children">;
  color?:
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | "inherit";
}

export const IconButton: React.FC<Props> = (props) => {
  const {
    tooltipProps,
    iconProps,
    disabled,
    color = "primary",
    ...buttonRest
  } = props;
  const { icon, size, ...iconRest } = iconProps;

  return (
    <Tooltip
      aria-disabled={disabled}
      {...tooltipProps}
      title={tooltipProps?.title}
    >
      <MUIconButton
        sx={(theme) => ({
          width: theme.spacing(4),
          height: theme.spacing(4),
        })}
        aria-disabled={disabled}
        color={color}
        disabled={disabled}
        {...buttonRest}
      >
        <Icon icon={icon} size={size || "xs"} {...iconRest} />
      </MUIconButton>
    </Tooltip>
  );
};
